import XLSX from 'xlsx';
import { TablePaginationConfig } from 'antd';

export const paginationProps = (totalData: number = 0): TablePaginationConfig => {
  return (
    {
      showSizeChanger: true,
      total: totalData,
      showTotal: (total, range) => `Showing ${range[0]}-${range[1]} of ${total} items`,
    }
  );
};

export const determineTagColor = (value: string) => {
  if (value.toLowerCase().includes('pending')) {
    return 'processing';
  }
  if (value.toLowerCase().includes('rejected')) {
    return 'error';
  }
  return 'success';
};

export const exportData = (data: any, fileName: string) => {
  const sheetData = XLSX.utils.json_to_sheet(data);
  const workBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workBook, sheetData);
  XLSX.writeFile(workBook, `${fileName}.xlsx`);
};
